import { el } from '../dom.js';
import { t, describeRecurrence, describeUntil, upcomingLabel, cancelledLabel } from '../i18n.js';
import { openSeriesForm } from './series-form.js';
import { api } from '../api.js';

const TRASH = 'M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16';

// One card, two workspaces. A person's own programme and an institution's are
// the same object at the same depth, so a second copy of this would be two
// answers to "what does a series look like in a list".
export function seriesCard(row, accountId, reload) {
  const until = describeUntil(row.recurrence);
  const open = () => openSeriesForm({ venueId: accountId, series: row, onSaved: reload });

  const card = el('div', { class: 'card card-button', tabindex: '0', role: 'button' }, [
    el('div', { class: 'row' }, [
      el('h3', { class: 'card-title' }, row.title),
      el('span', {
        class: `badge ${row.status === 'published' ? 'badge-live' : 'badge-draft'} row-end`,
      }, row.status === 'published' ? t.published : t.draft),
      el('button', {
        class: 'icon-button card-trash',
        type: 'button',
        title: t.deleteSeries,
        'aria-label': t.deleteSeries,
      }, icon(TRASH)),
    ]),
    el('p', { class: 'card-meta' }, [
      describeRecurrence(row.recurrence),
      ` · ${row.localStartTime}`,
      row.tags?.length ? ` · ${row.tags.join(', ')}` : '',
      until ? ` · ${until}` : '',
    ].join('')),
    el('p', { class: 'card-meta' },
      upcomingLabel(row.upcomingCount) +
      (row.cancelledCount ? `, ${cancelledLabel(row.cancelledCount)}` : '')),
  ]);

  card.addEventListener('click', open);
  card.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      open();
    }
  });

  // The trash stops the card from opening underneath it, and asks before
  // it costs anything — the same confirmation the series form uses.
  const trash = card.querySelector('.card-trash');
  trash.addEventListener('click', (event) => {
    event.stopPropagation();
    if (!window.confirm(t.deleteSeriesConfirm(row.title, row.upcomingCount ?? 0))) return;
    api.del(`/series/${row.id}`).then(() => reload(t.deletedSeries));
  });

  return el('li', {}, card);
}

function icon(d) {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', '14');
  svg.setAttribute('height', '14');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  svg.setAttribute('class', 'icon');
  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path.setAttribute('d', d);
  svg.append(path);
  return svg;
}
